export interface Webtoon {
  id: string;
  title: string;
  genre: string;
  genreLabel: string;
  status: "完结" | "连载" | "季终";
  rating: number;
  score: number;
  episode: number;
  tags: string[];
  summary: string;
  cover: string;
  highlight: string;
  editorsPick?: boolean;
}

export const categories = [
  "全部",
  "高分经典",
  "口碑佳作",
  "人气新作",
  "完结神作",
  "治愈系",
  "烧脑悬疑",
];

export const webtoons: Webtoon[] = [
  {
    id: "xindong-xinhao",
    title: "心动信号·自习室",
    genre: "高分经典",
    genreLabel: "高分经典",
    status: "完结",
    rating: 9.4,
    score: 9.1,
    episode: 128,
    tags: ["校园", "恋爱", "轻喜剧"],
    summary:
      "高三教室的最后一排，一个总把情书写成数学公式的少年，遇上转学而来的插班生。两人在无人问津的自习室里，用一张张纸条聊出了一个夏天的秘密。细腻到位的心理描写，被无数读者称为「校园恋爱天花板」。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20shy%20high%20school%20girl%20and%20boy%20in%20a%20bright%20classroom%20soft%20cherry%20blossom%20petals%20in%20the%20air%20pastel%20pink%20and%20cream%20tones%20clean%20minimal%20background%20delicate%20manhwa%20romance%20style%20high%20detail%20character%20illustration%20warm%20soft%20lighting%20vertical%20composition&width=600&height=800&seq=cover-romance-01&orientation=portrait",
    highlight: "把情书写成数学公式，这个夏天甜到犯规。",
    editorsPick: true,
  },
  {
    id: "shanhai-bianlidian",
    title: "山海便利店",
    genre: "人气新作",
    genreLabel: "人气新作",
    status: "连载",
    rating: 9.1,
    score: 8.8,
    episode: 42,
    tags: ["玄幻", "单元剧", "治愈"],
    summary:
      "深夜十二点才会出现的便利店，每扇货架门后都住着一只被封印的山海精怪。打工人林晚兼职夜班店员，白天收银，夜里帮精怪们实现一个个小而温柔的心愿。设定新、节奏轻，下饭神器。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20young%20hero%20holding%20a%20glowing%20lantern%20inside%20a%20magical%20convenience%20store%20full%20of%20floating%20ancient%20spirit%20jars%20deep%20teal%20and%20gold%20palette%20clean%20fantasy%20background%20high%20detail%20webtoon%20art%20dramatic%20rim%20lighting%20vertical%20composition&width=600&height=800&seq=cover-fantasy-01&orientation=portrait",
    highlight: "深夜便利店，贩卖温柔与山海精怪的秘密。",
  },
  {
    id: "diqijie-zhentan",
    title: "第七街的侦探",
    genre: "烧脑悬疑",
    genreLabel: "烧脑悬疑",
    status: "季终",
    rating: 9.3,
    score: 9.0,
    episode: 96,
    tags: ["推理", "悬疑", "刑侦"],
    summary:
      "整条街都知道，第七街的旧书店老板白天卖书，晚上破案。每一桩看似不可能的案子，都指向城市下水道里一段被掩埋的往事。多线叙事、伏笔回收干净利落，推理爱好者不容错过。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20trench%20coat%20detective%20standing%20in%20a%20rainy%20city%20alley%20at%20night%20glowing%20street%20lamps%20moody%20deep%20emerald%20and%20amber%20tones%20clean%20atmospheric%20noir%20manhwa%20illustration%20high%20detail%20vertical%20composition&width=600&height=800&seq=cover-mystery-01&orientation=portrait",
    highlight: "旧书店老板的白天与黑夜，藏着整座城市的秘密。",
  },
  {
    id: "mao-yudi",
    title: "猫与雨天电台",
    genre: "治愈系",
    genreLabel: "治愈系",
    status: "连载",
    rating: 9.2,
    score: 8.9,
    episode: 58,
    tags: ["治愈", "日常", "萌宠"],
    summary:
      "一只会读信的黑猫，经营着一家只在雨天开播的深夜电台。听众把心事写成信投进邮筒，黑猫在雨声里把它们一一读出来。没有狗血，没有反转，只有慢下来的生活与温柔的陪伴。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20girl%20with%20her%20cat%20listening%20to%20music%20by%20a%20rain%20streaked%20window%20warm%20golden%20and%20soft%20teal%20tones%20cozy%20atmosphere%20clean%20healing%20slice%20of%20life%20manhwa%20style%20high%20detail%20gentle%20soft%20lighting%20vertical%20composition&width=600&height=800&seq=cover-healing-01&orientation=portrait",
    highlight: "雨天限定电台，把心事说给会读信的黑猫听。",
    editorsPick: true,
  },
  {
    id: "quangongsi-modao",
    title: "全公司都知道我在摸鱼",
    genre: "口碑佳作",
    genreLabel: "口碑佳作",
    status: "连载",
    rating: 8.9,
    score: 8.6,
    episode: 71,
    tags: ["职场", "喜剧", "日常"],
    summary:
      "实习生阿久摸鱼技术出神入化，直到某天发现自己摸鱼时写的脑洞段子，竟被顶头上司一字不差地搬进了季度方案。从此「摸鱼」成了全公司的年度关键词。笑点密集，打工人的嘴替。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20relaxed%20young%20office%20worker%20sipping%20coffee%20at%20a%20cluttered%20desk%20surrounded%20by%20floating%20memo%20papers%20cheerful%20coral%20and%20cream%20palette%20clean%20modern%20office%20background%20funny%20light%20hearted%20manhwa%20art%20high%20detail%20vertical%20composition&width=600&height=800&seq=cover-office-01&orientation=portrait",
    highlight: "打工人的嘴替，摸鱼也能摸出一部职场神作。",
  },
  {
    id: "wudu-shipin",
    title: "雾都食刻",
    genre: "烧脑悬疑",
    genreLabel: "烧脑悬疑",
    status: "连载",
    rating: 9.0,
    score: 8.8,
    episode: 63,
    tags: ["惊悚", "悬疑", "美食"],
    summary:
      "整座城市常年笼罩在浓雾里，唯一亮着灯的，是一家只在雾夜营业的餐厅。端上桌的每一道菜，都对应着一位食客深埋心底的执念。胆小的别半夜看，但真的停不下来。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20woman%20opening%20an%20old%20misty%20restaurant%20door%20at%20night%20mysterious%20fog%20and%20warm%20dim%20lantern%20light%20deep%20emerald%20and%20amber%20tones%20suspenseful%20atmospheric%20manhwa%20illustration%20clean%20moody%20background%20high%20detail%20vertical%20composition&width=600&height=800&seq=cover-thriller-01&orientation=portrait",
    highlight: "雾夜限定的餐厅，每一道菜都是食客的心结。",
  },
  {
    id: "zhuifeng-shaonian",
    title: "追风少年",
    genre: "人气新作",
    genreLabel: "人气新作",
    status: "连载",
    rating: 8.8,
    score: 8.5,
    episode: 38,
    tags: ["运动", "热血", "青春"],
    summary:
      "因为一场赌约误入田径队的少年，从垫底一路冲进校队主力。燃烧、成长、队友情，节奏明快的热血漫改感扑面而来，运动番爱好者闭眼入。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20determined%20teenage%20sprinter%20crossing%20a%20finish%20line%20under%20dramatic%20golden%20stadium%20lights%20energetic%20motion%20warm%20orange%20and%20cream%20palette%20clean%20dynamic%20sports%20manhwa%20style%20high%20detail%20vertical%20composition&width=600&height=800&seq=cover-sports-01&orientation=portrait",
    highlight: "从垫底冲进主力的热血田径物语。",
  },
  {
    id: "wuhou-mianbaodian",
    title: "午后的面包店",
    genre: "治愈系",
    genreLabel: "治愈系",
    status: "完结",
    rating: 9.0,
    score: 8.8,
    episode: 84,
    tags: ["日常", "治愈", "美食"],
    summary:
      "小城街角的一家面包店，店主每天用刚出炉的面包，接住附近居民们各自的小烦恼。没有宏大叙事，只有面粉、烤箱与暖烘烘的人情味，适合配着热茶慢慢读。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20cheerful%20baker%20carrying%20a%20tray%20of%20fresh%20bread%20in%20a%20sunlit%20bakery%20golden%20afternoon%20light%20warm%20honey%20and%20cream%20tones%20clean%20cozy%20background%20gentle%20slice%20of%20life%20manhwa%20illustration%20high%20detail%20vertical%20composition&width=600&height=800&seq=cover-slice-01&orientation=portrait",
    highlight: "街角面包店，接住每个路人的小烦恼。",
  },
  {
    id: "jinxiugong",
    title: "锦绣宫",
    genre: "高分经典",
    genreLabel: "高分经典",
    status: "完结",
    rating: 9.3,
    score: 9.1,
    episode: 152,
    tags: ["古风", "宫廷", "权谋"],
    summary:
      "以一座暮年王朝的宫闱为舞台，讲述一位掌纹宫女如何用绣艺与心智，在波诡云谲的后宫棋局中步步为营。古风韵味十足，女性角色塑造立体，被称作「东方权谋神作」。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20an%20elegant%20woman%20in%20traditional%20hanbok%20standing%20in%20a%20serene%20palace%20garden%20with%20blooming%20cherry%20trees%20rich%20crimson%20and%20jade%20teal%20palette%20clean%20historical%20background%20detailed%20traditional%20manhwa%20illustration%20soft%20light%20vertical%20composition&width=600&height=800&seq=cover-historical-01&orientation=portrait",
    highlight: "一针一线，绣出暮年王朝的后宫棋局。",
  },
  {
    id: "wuye-danganju",
    title: "午夜档案局",
    genre: "口碑佳作",
    genreLabel: "口碑佳作",
    status: "连载",
    rating: 9.2,
    score: 8.9,
    episode: 77,
    tags: ["科幻", "单元剧", "悬疑"],
    summary:
      "城市档案馆的地下三层，有一间只在午夜开放的档案局。每一份无人认领的档案，都记载着一个被抹去的人生。设定清奇、脑洞密集，单元与主线交织得相当漂亮。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20an%20archivist%20in%20a%20futuristic%20library%20with%20floating%20holographic%20files%20warm%20amber%20and%20deep%20green%20neon%20accents%20clean%20scifi%20manhwa%20background%20high%20detail%20character%20art%20cinematic%20lighting%20vertical%20composition&width=600&height=800&seq=cover-scifi-01&orientation=portrait",
    highlight: "午夜限定的档案局，封存着被抹去的人生。",
  },
  {
    id: "laozhai-shieryan",
    title: "老宅的十二盏灯",
    genre: "完结神作",
    genreLabel: "完结神作",
    status: "完结",
    rating: 9.1,
    score: 8.9,
    episode: 106,
    tags: ["灵异", "悬疑", "单元剧"],
    summary:
      "山脚老宅每到深夜会亮起十二盏灯，每一盏灯对应一位不愿离去的故人。返乡整理祖宅的青年，在一盏一盏点亮灯火的同时，也拼出了家族被掩埋的往事。氛围到位，结局封神。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20an%20old%20rustic%20house%20with%20twelve%20lantern%20windows%20glowing%20at%20midnight%20in%20a%20misty%20forest%20eerie%20warm%20candlelight%20deep%20forest%20green%20and%20amber%20tones%20clean%20spooky%20atmosphere%20detailed%20manhwa%20horror%20illustration%20vertical%20composition&width=600&height=800&seq=cover-horror-01&orientation=portrait",
    highlight: "点亮十二盏灯，拼出被掩埋的家族往事。",
  },
  {
    id: "sancan-siji",
    title: "三餐四季",
    genre: "完结神作",
    genreLabel: "完结神作",
    status: "完结",
    rating: 9.4,
    score: 9.2,
    episode: 132,
    tags: ["家庭", "亲情", "治愈"],
    summary:
      "以三代人的一日三餐为线，串起一座小城里几十年的悲欢离合。没有夸张的情节，只有柴米油盐里最扎实的亲情。看完只想给家里人打个电话。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20multi%20generational%20family%20sharing%20a%20warm%20dinner%20around%20a%20round%20table%20nostalgic%20golden%20light%20soft%20cream%20and%20terracotta%20palette%20clean%20heartfelt%20slice%20of%20life%20manhwa%20style%20high%20detail%20vertical%20composition&width=600&height=800&seq=cover-drama-01&orientation=portrait",
    highlight: "柴米油盐里，藏着三代人的三餐四季。",
    editorsPick: true,
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "好看的韩漫推荐真的靠谱吗，会不会踩雷？",
    a: "本站每部作品都经过编辑试读并综合参考豆瓣评分与读者好评筛选，会标注完结/连载状态与站内评分，尽量帮你避开高开低走或烂尾雷区。榜单随作品口碑动态更新，放心入坑。",
  },
  {
    q: "推荐的韩漫都是免费阅读的吗？",
    a: "大部分连载中的韩漫在官方平台上都可以免费试读或观看部分章节。我们只做推荐和评分参考，正版阅读请前往作品的官方连载平台，尊重创作者的劳动成果。",
  },
  {
    q: "怎么看一部韩漫会不会烂尾？",
    a: "可以先看作品完结状态、集数与平台评分曲线，再参考读者评论中「高开低走」「烂尾」等关键词出现的频率。本站的高分经典与完结神作栏目，正是为你筛选出的稳定完结佳作。",
  },
  {
    q: "推荐里带「连载」标签的能现在入坑吗？",
    a: "可以。我们会优先推荐设定扎实、口碑已经跑出来的连载作品，并标注当前话数。如果你不想追更，可以先从完结神作和高分经典两个栏目入手。",
  },
  {
    q: "你们的口碑评分和豆瓣评分有什么区别？",
    a: "豆瓣评分为站外公开评分参考，代表大众综合口碑；站内编辑评分则侧重于剧情完成度、画工与追读体验，两者结合可以更全面地判断一部韩漫是否值得一看。",
  },
  {
    q: "有没有适合「下饭」看的轻量韩漫？",
    a: "有。治愈系与口碑佳作两个栏目收录了大量轻松、单元化、适合碎片时间阅读的作品，比如《山海便利店》《猫与雨天电台》《午后的面包店》，都不需要太多精力投入。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "南巷",
    role: "追漫六年 · 完结党",
    content:
      "按这个榜单把《三餐四季》和《锦绣宫》补完了，确实没有一部踩雷，评分水分很低，推荐顺序也合理。",
  },
  {
    name: "阿黎",
    role: "上班族 · 下饭番",
    content:
      "「治愈系」栏目简直是打工人的福音，每天午休读两话《山海便利店》，一天的疲惫都被治愈了。",
  },
  {
    name: "凉柚",
    role: "推理爱好者",
    content:
      "冲着烧脑悬疑去的，结果《第七街的侦探》和《雾都食刻》都太对味了，伏笔回收干净，强烈推荐。",
  },
];

export const guideTips = [
  {
    icon: "ri-book-open-line",
    title: "先看完结与话数",
    desc: "优先选择已完结、集数稳定的作品，避免追到一半断更或烂尾，先从高分经典和完结神作入手最稳妥。",
  },
  {
    icon: "ri-star-smile-line",
    title: "参考双评分",
    desc: "豆瓣评分代表大众综合口碑，站内评分侧重剧情完成度与画工。两者都高，通常就是值得入坑的口碑佳作。",
  },
  {
    icon: "ri-slideshow-line",
    title: "按类型筛选",
    desc: "根据当下的心情选类型：通勤下饭选治愈系与喜剧，晚上独处选烧脑悬疑，想认真追剧情选高分经典。",
  },
  {
    icon: "ri-feedback-line",
    title: "看读者真实反馈",
    desc: "滑到评论区看看「高开低走」「烂尾」等关键词出现的频率，再决定要不要花时间入坑，能有效避开雷区。",
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20korean%20webtoon%20comic%20panels%20colorful%20stylized%20manhwa%20characters%20and%20speech%20bubbles%20floating%20on%20a%20warm%20cream%20background%20coral%20teal%20and%20amber%20palette%20clean%20artistic%20magazine%20cover%20style%20high%20detail%20horizontal%20composition&width=1600&height=900&seq=hero-kcomic&orientation=landscape";